
const { default: api } = require("services/api.service");

export const sendContactForm = async (data) => {
    return await api.request('/contact/form', {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
    }, 200)
}